console.log("Custom scripts loaded!");

// Import modules
import "./components/lightbox.js";

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOM ready!");
});
